import caches from './caches';
import { ElLoading } from 'element-plus';

const local = {
  available: false,
  availableList: [],
  isInited: false,
  callLocal(method, data) {
    return new Promise((resolve, reject) => {
      // 本地执行
      window.electronAPI.callJava(method, data);
      // 等待响应
      window.electronAPI.onJavaResponse((resp) => {
        resp = JSON.parse(resp);
        if (resp.success) {
          resolve(resp)
        } else {
          reject(resp)
        }
      })
    })
  },
  request(mapping, data = {}) {
    return new Promise((resolve, reject) => {
      // 使用Fetch模拟
      fetch('http://127.0.0.1:8890/$base' + mapping+'?uid='+caches.userinfo.id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 5000,
        body: JSON.stringify(data)
      }).then(response => {
        if (!response.ok) {
          reject(new Error('Network response was not ok'));
        }
        return response.json();
      })
      .then(resolve)
      .catch(reject);
    })
  },
  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  async init() {
    if (this.isInited) return;
    this.isInited = true;
    if(window.electronAPI) {
      const loading = ElLoading.service();
      loading.setText('正在启动本地思易节点环境...');
      try {
        await this.request('/alive');
        this.available = true;
      } catch (e) {
        await this.callLocal('start-node')
      }
      loading.setText('正在初始化本地思易节点环境，请稍候...');
      let times = 120;
      while (!this.available) {
        this.delay(1000);
        try {
          await this.request('/alive');
          this.available = true;
          break;
        } catch (e) {
          if (--times <= 0) {
            alert('启动本地思易节点环境失败！请确保本地8890端口没有被占用。');
            window.close();
            return;
          }
        }
      }
      loading.setText('启动成功!');
      await this.delay(1500);
      loading.close();
      
      setInterval(() => {
        this.request('/alive').then(() => {
          this.available = true;
        }).catch(() => {
          this.callLocal('start-node').then(() => {
            this.available = true;
          }).catch(() => {
            this.available = false;
            alert('启动本地思易节点环境失败！请确保本地8890端口没有被占用。');
          })
        })
      }, 60 * 1000)
    }
  },
  async reloadProject(pid) {
    await this.request('/project/delete', {pid});
    await this.request('/project/add', {pid});
  },
  async reloadService(sid) {
    await this.request('/service/delete', {sid});
    await this.request('/service/add', {sid});
  },
  async unloadProject(pid) {
    await this.request('/project/delete', {pid});
  },
  async unloadService(sid) {
    await this.request('/service/delete', {sid});
  },
  startNode(nid, uid, password) {
    this.callLocal('start-node', nid, uid, password).then((resp) => {
      this.availableList[nid] = resp.data;
    }).catch(() => {
      alert('启动节点失败！请确保本地对应端口没有被占用，且网络连接正常。');
    })
  },
  stopNode(nid) {
    this.callLocal('stop-node', this.availableList[nid]).then(() => {
      this.available = false;
      delete this.availableList[nid];
    }).catch(() => {
      alert('停止节点失败！请确保网络连接正常。');
    })
  }
}

local.init()

export default local;